module.exports = __webpack_public_path__ + "img/icons_13.19e1c4b7.png";